import React from 'react'
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import HandshakeIcon from '@mui/icons-material/Handshake';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';

const Quates = () => {
  return (
    <div>
      <div className="  ">
        <div className="md:flex justify-around h-80 gap-4 items-center max-sm:h-auto ">
          <div className="flex justify-center items-center flex-col md:p-6 max-sm:my-5 max-sm:bg-gray-800 max-sm:w-96 max-sm:m-auto max-sm:p-10 max-sm:text-white">
            <div className="border rounded-full  w-28 h-28 hover:bg-red-200 z-30 flex justify-center items-center ">
              <WaterDropIcon sx={{ fontSize: 40 }} className=" hover:z-50 w-full h-full mb-2" />
            </div>
            <h1 className='text-3xl font-semibold '>Quality Water</h1>
          </div>
          <div className="flex justify-center items-center flex-col md:p-6 max-sm:my-5 max-sm:bg-gray-800 max-sm:w-96 max-sm:m-auto max-sm:p-10 max-sm:text-white">
            <div className="border rounded-full  w-28 h-28 hover:bg-red-200 z-30 flex justify-center items-center ml-5 mb-2">
              <HandshakeIcon sx={{ fontSize: 40 }} className=" hover:text-black z-50 w-full h-full" />
            </div>
            <h1 className='text-3xl font-semibold '>Help People</h1>
          </div>
          <div className="flex justify-center items-center flex-col md:p-6 max-sm:my-5 max-sm:bg-gray-800 max-sm:w-96 max-sm:m-auto max-sm:p-10 max-sm:text-white">
            <div className="border rounded-full  w-28 h-28 hover:bg-red-200 text-red-200z-30 flex justify-center items-center ml-5  mb-2">
              <CurrencyExchangeIcon sx={{ fontSize: 40 }} className=" hover:text-black z-50 w-full h-full" />
            </div>
            <h1 className='text-3xl font-semibold '>Save Money</h1>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Quates